import get from 'lodash/get';
import moment from 'moment';
import {useState} from 'react';
import {connect} from 'react-redux';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {useGetSessionTypesQuery} from '../../redux/services/sessionTypeApi';
import {useGetProvidersQuery} from '../../redux/services/providerApi';
import AppointmentSummary from '../scheduling/AppointmentSummary';

const AlreadyScheduledDialog = props => {
  console.log('PROPS', props);
  const {alreadyScheduled, providerId, scheduleManually, sessionTypeId, date, time} = props;
  const [dialogClosed, setDialogClosed] = useState(false);
  const sessionTypeQuery = useGetSessionTypesQuery({id: sessionTypeId}, {skip: !sessionTypeId});
  const providerQuery = useGetProvidersQuery({id: providerId}, {skip: !providerId});
  const provider = get(providerQuery, 'data[0]', null);
  const sessionType = get(sessionTypeQuery, 'data[0]', null);
  return (
    <Dialog maxWidth='xs' open={alreadyScheduled && !dialogClosed} onClose={() => setDialogClosed(true)}>
      <DialogTitle>
        <Typography variant='h2' align='center'>Create Account to Complete Booking</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {provider && sessionType &&
            <AppointmentSummary 
              provider={provider} 
              sessionType={sessionType}
              date={moment(date)}
              time={time}
              scheduleManually={scheduleManually}
            />
          }
          <Typography variant='body'>
            We’re thrilled to help you move and live your best! To complete your session booking or to contact your provider directly, please complete your account registration.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDialogClosed(true)}>Okay</Button>
      </DialogActions>
    </Dialog>
  );
};

const mapState = state => ({
  sessionTypeId: get(state, 'newAppointmentForm.sessionTypeId', null),
  date: get(state, 'newAppointmentForm.date', null),
  time: get(state, 'newAppointmentForm.time', null),
  scheduleManually: get(state, 'newAppointmentForm.scheduleManually', null),
});

const mapDispatch = dispatch => ({
});

export default connect(mapState, mapDispatch)(AlreadyScheduledDialog);